const LAY_TAT_CA_APP_THANH_CONG = (state, tatCaApp) => {
    state.tatCaApp = tatCaApp;
};

const LAT_LIST_APP_THANH_CONG = (state, listApp) => {
  state.listApp = listApp;
};

const LAY_DANH_SACH_APP_PAGING_THANH_CONG = (state, danhSachAppPaging) => {
    state.danhSachAppPaging = danhSachAppPaging;
};

export default {
  LAY_TAT_CA_APP_THANH_CONG,
  LAY_DANH_SACH_APP_PAGING_THANH_CONG,
  LAT_LIST_APP_THANH_CONG,
};
